export const SUGGESTION_OPTION_COUNT = 3;
export const SUGGESTION_OPTION_MAX_CHARACTERS = 160;
export const MIN_CHARACTER_COUNT = 10;

export enum CopyAssistEmailMediumData {
  preheaderText = 'preheaderText',
  subject = 'subject',
}

export enum CopyAssistPushMediumData {
  title = 'title',
  message = 'message',
}

export enum CopyAssistSMSMediumData {
  message = 'message',
}

export enum CopyAssistWhatsAppMediumData {
  message = 'message',
}

export enum Tag {
  TextArea = 'textarea',
  Input = 'input',
}
